import React from "react";
import {Icon} from '@fluentui/react';


class Warning extends React.Component {
    render() {

        const warningIcon = this.props.element
                            ? <div className={`warning-inline warning-${this.props.element}`}><Icon iconName="Warning" title={this.props.title} /></div>
                            : <div className='warning'><Icon  iconName="Warning" title={this.props.title} /></div>

        return (
            <div>
                {warningIcon}
            </div>
        );
    }
}
export default Warning



// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/Warning.js